module.exports = __webpack_public_path__ + "files/53559927cf734a2f50499682e329cb70.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-6.png
// module id = 1399
// module chunks = 59